export default "/static/liconic_stx_tiny.png";